// Core
import React from 'react';

// Libraries
import { useTranslation } from 'react-i18next';

// Plugins
import {
  DEVICE_COMMUNICATION_THRESHOLD,
  isEquipmentRunning,
} from '../../../../../../plugins/crusher';

// Components
import { Col } from '../../../../../../layout/elements/Col';
import { ModuleHeader } from '../../../../../../layout/elements/ModuleHeader';
import { Row } from '../../../../../../layout/elements/Row';
import { VibrationThermometer } from '../../../../../../components/VibrationThermometer';

// View
import { VibrationProps } from './Vibration.types';
import { VibrationContainer, ThermometerContainer } from './Vibration.style';

function Vibration({
  className,
  unitData,
  edgeStatus,
  onOpenDrawer,
  testId,
}: VibrationProps): JSX.Element {
  // Dependencies
  const { t } = useTranslation();

  return (
    <VibrationContainer
      data-testid={testId}
      className={className}
    >
      <Row>
        <Col>
          <ModuleHeader
            onClick={onOpenDrawer}
            title={t('view.crusher.vsi.vibration.title')}
          />
        </Col>
      </Row>
      <ThermometerContainer>
        <VibrationThermometer
          unit="%"
          title={`${t('view.crusher.vsi.vibration.title')}`}
          minValue={0}
          maxValue={100}
          decimalPlaces={0}
          value={unitData?.vibrationSensor1}
          running={
            isEquipmentRunning(
              edgeStatus,
              unitData?.timestamp,
              DEVICE_COMMUNICATION_THRESHOLD,
            )
          }
          thresholds={{
            highWarning: unitData?.spVibration1Warning,
          }}
          testId="vibration-sensor-1-thermometer"
        />
      </ThermometerContainer>
    </VibrationContainer>
  );
}

export { Vibration };
